// A2-581 walk W22 — an unfilled replaced calculation's form address moves to
// the current calculation (loadCountryReturn.js). The figures on the page are
// then not the ones the address was opened for, so the page says so.
import React from "react";
import { useTranslation } from "react-i18next";

export default function ReplacedCalcNote() {
  const { t } = useTranslation();
  return (
    <p
      data-testid="country-return-replaced-note"
      role="status"
      className="mb-4 rounded border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 px-3 py-2 text-sm text-slate-700 dark:text-slate-200"
    >
      {t("ui.country_return.page.replaced_calc_note", {
        defaultValue: "The calculation you opened has been replaced, so this is the form of the newer calculation.",
      })}
    </p>
  );
}
